import React from "react";
import { Link } from "react-router-dom";
import landingPageBg from "../../assets/img/landing-page/landing-page-bg.png";
// import googleIcon from "../../assets/img/landing-page/googleIcon.png";
import googleIcon from "../../Utilities/google-chrome-store.png";
import starIcon from "../../assets/img/landing-page/star.svg";
import bannerImage from "../../assets/img/landing-page/banner-image.png";

import "./style.css";
import "../../assets/styles/main.css";
import "../../assets/styles/responsive.css";
import HomeBrands from "../home/components/homeBrands/homebrands";
import ReachYourIdeas from "./components/reachYourIdeas/reachYourIdeas";
import FreeService from "./components/freeService/freeService";
import IdealCustomers from "./components/idealCustomers/idealCustomers";
import LandingPageTestimonial from "../../components/landingPageTestimonial/landingPageTestimonial";
import LeadbudIdealCustomers from "./components/leadbudIdealCustomer/LeadbudIdealCustomers";
import CTA_BG from "../../assets/img/CTA BG.png";
import { FaChevronDown } from "react-icons/fa";
const LandingPage = () => {
  return (
    <div className="landing-page-wrapper">
      <div className="landing-page-inner">
        <div
          className="bg-container"
          style={{
            backgroundImage: `url(${landingPageBg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 100%",
            paddingTop: "100px",
            paddingBottom: "200px",
            position: "relative",
          }}
        >
          <div
            className="landing-page-banner container"
            style={{ marginTop: "25px" }}
          >
            {" "}
            <div className="content-area">
              <div className="row">
                <div
                  className="col-lg-6 col-md-12 col-sm-12 col-xs-12 landing-page-item"
                  style={{ marginBottom: "60px" }}
                >
                  <div className="content">
                    <h1 style={{ fontWeight: "300 " }}>
                      <span>
                        Reach the
                        <br />
                        right {}
                        <span
                          style={{
                            display: "inline-block",
                            fontWeight: "700 !important",
                          }}
                        >
                          <p
                            style={{
                              fontWeight: "700",
                            }}
                          >
                            decision makers
                          </p>
                        </span>
                      </span>
                    </h1>

                    <p>
                      Sell more and close more with the most accurate <br /> B2B
                      company and contact data.
                    </p>

                    <div className="button-area aos-init aos-animate">
                      <div
                        className="landing-page-input"
                        style={{ display: "flex" }}
                      >
                        <input type="email" placeholder="Enter your email" />
                        <Link
                          to={"/users/login"}
                          className="btn btn-get-started"
                        >
                          Start trail
                        </Link>
                      </div>

                      <div className="google-ratting">
                        <img
                          src={googleIcon}
                          alt="Google Icon"
                          srcset=""
                          style={{ height: "auto", width: "20px" }}
                        />
                        <p>
                          <img src={starIcon} alt="Star" />
                          4,8 / 5 In the Google Chrome Store
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="items  ">
                    <div className="item">
                      <i class="fa-solid fa-circle-check"></i>
                      <p>CCPA Complaint</p>
                    </div>
                    <div className="item">
                      <i class="fa-solid fa-circle-check"></i>
                      <p>GDRP Complaint</p>
                    </div>
                    <div className="item">
                      <i class="fa-solid fa-circle-check"></i>
                      <p>ISO 1254 Complaint</p>
                    </div>
                  </div>
                </div>

                <div
                  className="col-lg-6 col-md-12 col-sm-12 col-xs-12"
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "flex-start",
                  }}
                >
                  <div
                    className="image-area landing-page-image-area"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "20px",
                      width: "500px",
                    }}
                  >
                    <img style={{ height: "auto" }} src={bannerImage} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ paddingBottom: 0 }}>
          <HomeBrands />
        </div>
        <div style={{ paddingBottom: 0, marginTop: "25px" }}>
          <ReachYourIdeas />
        </div>
        <div style={{ paddingBottom: 0 }}>
          <FreeService />
        </div>
        <div style={{ paddingBottom: 0 }}>
          <IdealCustomers />
        </div>
        <div style={{ paddingBottom: 0, marginTop: "25px" }}>
          <LandingPageTestimonial />
        </div>
        <div style={{ paddingBottom: 0 }}>
          <LeadbudIdealCustomers />
        </div>
       
      </div>
    </div>
  );
};

export default LandingPage;
